import { CalcLeavesController } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";

/**
 * Displays payments for current calculation period.
 * @example
 * ```html
 * <salaxy-calc-leaves ng-ref="$calcLeaves" calc="$ctrl.current.calc" worktime="$ctrl.current.worktime"></salaxy-calc-leaves>
 * ```
 */
export class CalcLeaves extends ComponentBase {

   /**
    * The following component properties (attributes in HTML) are bound to the Controller.
    * For detailed functionality, refer to [controller](#controller) implementation.
    */
    public bindings = {
      /** The calculation*/
      calc: "<",
      /** The worktime*/
      worktime: "<",
    };

    /** Uses the CalcLeavesController */
    public controller = CalcLeavesController;

    /** The default template for the component. */
    public defaultTemplate = "salaxy-components/calc/CalcLeaves.html";

}
